"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";

export type BodySizeChart = {
  ageRangeLabel: string;
  sizeCode: string;
  displayOrder: number;
};

interface BodySizeTableProps {
  data: BodySizeChart[];
}

export function BodySizeAccordion({ data }: BodySizeTableProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        Gösterilecek veri bulunamadı.
      </div>
    );
  }

  const sortedData = [...data].sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <div className="w-full max-w-xl mx-auto rounded-lg overflow-hidden border border-gray-200 shadow-sm">
      <div className="grid grid-cols-2 bg-[#8fa5b5] px-6 py-4">
        <span className="text-white font-semibold text-base">Yaş</span>
        <span className="text-white font-semibold text-base text-right">
          Beden
        </span>
      </div>

      {sortedData.map((item, index) => (
        <button
          className={cn(
            "w-full grid grid-cols-2 px-6 py-4 text-left transition-colors",
            activeIndex === index && "bg-[#0ca0d8] text-white",
            activeIndex !== index && index % 2 === 0 && "bg-white text-gray-800 hover:bg-gray-100",
            activeIndex !== index && index % 2 !== 0 && "bg-gray-50 text-gray-800 hover:bg-gray-100",
          )}
          key={item.sizeCode + item.displayOrder}
          onClick={() => setActiveIndex((prev) => (prev === index ? null : index))}
          type="button"
        >
          <span className="text-base font-medium">{item.ageRangeLabel}</span>
          <span className="text-base font-medium text-right">
            {item.sizeCode}
          </span>
        </button>
      ))}
    </div>
  );
}
